import React from 'react'

import AggregateShellComponent from "../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    value: any

    type                        : 'list' | 'table' | 'gantt' | 't-list'
    aggregateFunction           : string

    isFirstInBlock              : boolean
    isLastInBlock               : boolean

    onChangeAggregateFunction   : callback          //for more button
}

export default function AggregateTimeComponent(options: any[], props: Props) {

    const isValid   = !_.isNil(props.value) && !_.isNaN(props.value)
    const value     = isValid ? gd.utils.minutesHumanize(props.value) : 'No data'

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:
            noDataLabel = '0'
            break

        default:
            noDataLabel = gd.const.aggregate.label[props.aggregateFunction]
            break
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={value} {...props}>
            {isValid &&
                <>
                    <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                    <div className="aggregate-value aggregate-number">{value}</div>
                </>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}
